import { CLEAR_ERRORS } from './types';

// Clear Errors Action
export const clearErrors = () => {
  return {
    type: CLEAR_ERRORS
  };
};



// WEBPACK FOOTER //
// ./src/actions/errorActions.ts